import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    btn: {
        display: 'inline-block',
        padding: '5px 12px',
        fontSize: '14px',
        color: '#00a3f9',
        background: 'none',
        border: '1px solid #00a3f9',
        borderRadius: 12,
        cursor: 'pointer',

        '&:hover': {
            borderColor: 'rgba(255,255,255,.15)',
            color: '#ffce01'
        }
    }
}))

const columns = [
    { id: 'id', label: 'ID'},
    { id: 'login', label: 'Логин'},
    { id: 'balance', label: 'Баланс'},
    { id: 'percent', label: 'Процент'},
    { id: 'count_registration', label: 'Колличество регистраций'},
    { id: 'count_deposit', label: 'Колличество депозитов'},
    { id: 'promocode', label: 'Промокод'},
    { id: 'withdrawal', label: 'Выдать'},
];

const getRows = (data) => {
    return data.map((item) => {
            return {
                id: item.id,
                login: item.login,
                balance: item.balance,
                percent: item.percent,
                count_registration: item.count_registration,
                count_deposit: item.count_deposit,
                promocode: item.promocode
            }
    })
}

export {
    useStyles,
    columns,
    getRows
}